export default (item, labels) => {
	let title = labels.gaLinkStatusLabel.find((r) => r.id === item.linkRequest)?.displayName;
	if (title === undefined) title = '-';
	return title;
};
